import {initCore} from "./core/index.js";
import {initCompat} from "./compat/index.js";
import {initUi} from "./ui/index.js";
import {initModules} from "./modules/index.js";
import {initRouter} from "./router/index.js";

const initApp = async () => {

  console.log("🚀 Initializing App...");
  initCompat();         // 互換性対応
  await initCore();     // プロジェクト全体に影響を与えるコアモジュール（barbaJS, Lenis, GsapScrollSmooter etc）
  await initModules();  // 特定のエリア・機能に限定したモジュール
  await initUi();       // UI
  await initRouter();   // 各ページ別処理（共通処理含む）
  console.log("🚀 Complete App...");
};

document.addEventListener("DOMContentLoaded", initApp);

